module.exports = __webpack_public_path__ + "media/images/pc/visit_reserve/about-planner-b2cde2fa437133a99b7cab527719f014.png";